import { useMutation, useQueryClient } from '@tanstack/react-query'
import { axiosInstance } from '@/lib/axios'
import type { BootstrapRequest, TenantMe } from '../types'

export function useMutationBootstrapTenant() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (body: BootstrapRequest): Promise<{ companyId: string }> => {
      const { data } = await axiosInstance.post('/config-api/tenant/bootstrap', body)
      return data
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['tenant.me'] })
    },
  })
}
